import { render, staticRenderFns } from "./StandappPersonalDetailComponent.vue?vue&type=template&id=35f459b9&"
import script from "./StandappPersonalDetailComponent.vue?vue&type=script&lang=js&"
export * from "./StandappPersonalDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports